var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrld-overview mb-4"},[_c('v-row',{attrs:{"align":"center","justify":"space-between"}},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("headerBtns")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }